export default "__VITE_ASSET__BQY1yu3e__"